import { render, staticRenderFns } from "./modalLimitExceeded.vue?vue&type=template&id=38963294&scoped=true"
import script from "./modalLimitExceeded.vue?vue&type=script&lang=js"
export * from "./modalLimitExceeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38963294",
  null
  
)

export default component.exports